export default {
  init() {
    // Boot Boostrap 4 MeterialDesign
    $('body').bootstrapMaterialDesign({ ripples: false });

    $(function() {
      $('.main-slider').slick({
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        arrows: false,
        autoplay: true,
      });

      $('.item-slider').slick({
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 840,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    });

    // JavaScript to be fired on all pages
    $('[data-trigger]').on('click', function(){
      var trigger_id =  $(this).attr('data-trigger');
      $(trigger_id).toggleClass('show');
      $('body').toggleClass('toggle-noscroll');
    });

    // Javascript to enable link to tab
    var url = document.location.toString();
    if (url.match('#tab-')) {
      $('.nav-tabs a[href="#' + url.split('#tab-')[1] + '"]').tab('show');
    }

    // Change hash for page-reload
    $('.nav-tabs a').on('shown.bs.tab', function (event) {
      window.location.hash = 'tab-' + event.target.hash.split('#')[1];
    })
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js